import React from 'react';

// Filet de securite : une erreur de rendu React n'affiche plus un ecran blanc
// mais un message clair + un bouton pour recharger.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // Log console (repris par le monitoring si branche plus tard).
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1rem', textAlign: 'center', padding: '2rem', color: '#fff', background: '#1a1a2e' }}>
          <div style={{ fontSize: '3rem' }}>😵</div>
          <h1 style={{ margin: 0 }}>Oups, une erreur est survenue</h1>
          <p style={{ opacity: 0.8, maxWidth: 420 }}>L'application a rencontre un probleme inattendu. Recharge la page pour continuer.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: '0.6rem 1.4rem', fontWeight: 700, fontSize: '1rem', color: '#1a1a2e', background: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}
          >Recharger</button>
        </div>
      );
    }
    return this.props.children;
  }
}
